'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdWifiTethering = function MdWifiTethering(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 5c9.2 0 16.6 7.4 16.6 16.6 0 6.2-3.2 11.6-8.2 14.5l-1.8-2.9c4-2.3 6.8-6.6 6.8-11.6 0-7.3-6.1-13.2-13.4-13.2s-13.4 5.9-13.4 13.2c0 5 2.7 9.3 6.7 11.6l-1.7 2.9c-5-2.9-8.2-8.3-8.2-14.5 0-9.2 7.4-16.6 16.6-16.6z m10 16.6c0 3.7-2 7-5 8.7l-1.6-2.9c1.9-1.1 3.2-3.3 3.2-5.8 0-3.6-2.9-6.6-6.6-6.6s-6.6 3-6.6 6.6c0 2.5 1.3 4.7 3.2 5.8l-1.6 2.9c-3-1.7-5-5-5-8.7 0-5.5 4.5-10 10-10s10 4.5 10 10z m-10-3.2c1.8 0 3.4 1.4 3.4 3.2s-1.6 3.4-3.4 3.4-3.4-1.6-3.4-3.4 1.6-3.2 3.4-3.2z' })
        )
    );
};

exports.default = MdWifiTethering;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/wifi-tethering.js
// module id = 1629
// module chunks = 36573943044255 79611799117203 213534597649335